var _rect, _rect2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#47BBA9",
    fillOpacity: 0.36
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.99805,
    y: 8.00002,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#47BBA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2187 29.1873C25.1314 29.1873 24.25 30.0688 24.25 31.1561V50.8436C24.25 51.9309 25.1314 52.8123 26.2187 52.8123H53.7812C54.8685 52.8123 55.75 51.9309 55.75 50.8436V31.1561C55.75 30.0688 54.8685 29.1873 53.7812 29.1873H26.2187ZM21.625 31.1561C21.625 28.619 23.6817 26.5623 26.2187 26.5623H53.7812C56.3183 26.5623 58.375 28.619 58.375 31.1561V50.8436C58.375 53.3806 56.3183 55.4373 53.7812 55.4373H26.2187C23.6817 55.4373 21.625 53.3806 21.625 50.8436V31.1561Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1515 32.319C27.5966 31.7468 28.4212 31.6438 28.9934 32.0888L40.0001 40.6496L51.0067 32.0888C51.5789 31.6438 52.4035 31.7468 52.8486 32.319C53.2936 32.8912 53.1905 33.7158 52.6183 34.1608L40.8058 43.3483C40.3319 43.717 39.6682 43.717 39.1943 43.3483L27.3818 34.1608C26.8096 33.7158 26.7065 32.8912 27.1515 32.319Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.701437a24a73f0e6e01af97d0fd1a017.svg";
export { ForwardRef as ReactComponent };